export function centsToDisplay(cents) {
  return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

// "1,234.56" | "1234.5" | "12" -> integer cents (or null if unparseable)
export function dollarsToCents(input) {
  const s = String(input).replace(/[$,\s]/g, "");
  if (!/^\d*\.?\d{0,2}$/.test(s) || s === "" || s === ".") return null;
  return Math.round(Number.parseFloat(s) * 100);
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
